import React, { useEffect } from 'react'

const DownloadContact6 = () => {
   const fetchDownload=()=>{
    var vCardData =
    "BEGIN:VCARD\r\n" +
    "VERSION:3.0\r\n" +
    "FN:Radha kids wear"+
    "\r\n" +
    "N:Radha kids wear"+
    ";;;\r\n" +
    "TEL;TYPE=CELL:9884878221" +
    "\r\n"+
    "END:VCARD";

  var blob = new Blob([vCardData], { type: "text/vcard" });
  var downloadLink = document.createElement("a");
  downloadLink.href = URL.createObjectURL(blob);
  downloadLink.download = "Radha kids wear.vcf";
  downloadLink.style.display = "none";
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
   }

   useEffect(()=>{
    fetchDownload()
   })
  
    return (
    <div>
      
    </div>
  )
}

export default DownloadContact6